'use client';

import React, { useEffect } from 'react';
import CarouselGeneric from 'src/components/Carousel/CarouselGeneric';
import CardGeneric from 'src/components/Card/CardGeneric';
import TableWithColumns from 'slices/TableWithColumns';
import classNames from 'classnames';
import Loading from 'src/components/Loading/Loading';

/**
 * @typedef {import("@prismicio/client").Content.SectionBeforeAndAfterSlice} SectionBeforeAndAfterSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<SectionBeforeAndAfterSlice>} SectionBeforeAndAfterProps
 * @param { SectionBeforeAndAfterProps }
 */
const SectionBeforeAndAfter = ({ slice }) => {
    const [cards, setCards] = React.useState(null);

    useEffect(() => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                query: slice.items.map((item) => item.card.id),
            }),
            headers: {
                'Content-Type': 'application/json',
                charset: 'utf-8',
            },
            redirect: 'follow',
        };
        fetch('/prismic/api/get-type-by-ids', requestOptions)
            .then((response) => response.json())
            .then((result) => {
                // eslint-disable-next-line no-console
                setCards(result.results);
            });
    }, []);
    return (
        <section>
            {cards ? (
                <div className="container">
                    <CarouselGeneric>
                        {cards.map((card, index) => (
                            <div key={index} className="flex flex-wrap">
                                <CardGeneric
                                    image={{
                                        split: [
                                            {
                                                src: card.data.image_before.url,
                                                alt: card.data.image_before.alt,
                                                width: card.data.image_before
                                                    .dimensions.width,
                                                height: card.data.image_before
                                                    .dimensions.height,
                                            },
                                            {
                                                src: card.data.image_after.url,
                                                alt: card.data.image_after.alt,
                                                width: card.data.image_after
                                                    .dimensions.width,
                                                height: card.data.image_after
                                                    .dimensions.height,
                                            },
                                        ],
                                    }}
                                    sectionClassName={classNames('p-4')}
                                >
                                    <div className="flex w-full flex-nowrap justify-between">
                                        <span
                                            className={
                                                'font-heading text-md tracking-tight'
                                            }
                                        >
                                            {card.data.name}
                                            {card.data.age &&
                                                `, ${card.data.age}`}
                                        </span>
                                        <span className="text-regular">
                                            {card.data.state}
                                        </span>
                                    </div>
                                    {card.data.slices.length &&
                                        card.data.slices.map((slice, index) => {
                                            return (
                                                <TableWithColumns
                                                    slice={slice}
                                                    key={index}
                                                />
                                            );
                                        })}
                                </CardGeneric>
                            </div>
                        ))}
                    </CarouselGeneric>
                </div>
            ) : (
                <Loading />
            )}
        </section>
    );
};

export default SectionBeforeAndAfter;
